import { useRef, TouchEvent } from "react";

interface SwipeOptions {
    threshold?: number;
    restraint?: number;
}

interface SwipeHandlers {
    onTouchStart: (e: TouchEvent) => void;
    onTouchEnd: (e: TouchEvent) => void;
}

export function useSwipe(
    onSwipeLeft: () => void,
    onSwipeRight: () => void,
    { threshold = 50, restraint = 50 }: SwipeOptions = {}
): SwipeHandlers {
    const touchData = useRef({ startX: 0, startY: 0 });

    const onTouchStart = (e: TouchEvent) => {
        const t = e.touches[0];
        touchData.current.startX = t.clientX;
        touchData.current.startY = t.clientY;
    };

    const onTouchEnd = (e: TouchEvent) => {
        const t = e.changedTouches[0];
        const dx = t.clientX - touchData.current.startX;
        const dy = t.clientY - touchData.current.startY;

        if (Math.abs(dx) > threshold && Math.abs(dy) < restraint) {
            dx > 0 ? onSwipeRight() : onSwipeLeft();
        }
    };

    return { onTouchStart, onTouchEnd };
}
